export enum DigitalProductSourceEnum {
  DigitalStore = 'digital-store',
  Funnel = 'funnel',
}
